import { API_URL } from '../../config/api';
import { createProjectItemDocument, deleteProjectItemDocument } from '../../api/documents';
import { DocumentAttachment } from '../common/DocumentAttachment';

interface TabProjectPlanDocumentAttachmentProps {
  projectId: string;
  itemId: string;
  documentUrl?: string | null;
  fileName?: string | null;
  onDocumentChange?: (documentUrl: string | undefined, fileName: string | undefined) => void;
}

export const TabProjectPlanDocumentAttachment = ({ projectId, itemId, documentUrl, fileName, onDocumentChange }: TabProjectPlanDocumentAttachmentProps) => (
  <DocumentAttachment
    recordLabel="project plan item"
    recordKey={`${projectId}-${itemId}`}
    documentUrl={documentUrl}
    fileName={fileName}
    onDocumentChange={onDocumentChange}
    adapter={{
      upload: (token, file) => createProjectItemDocument(token, projectId, itemId, file),
      remove: (token) => deleteProjectItemDocument(token, projectId, itemId),
      downloadUrl: (name) => `${API_URL}/projects/${projectId}/items/${itemId}/document/${encodeURIComponent(name)}`,
    }}
  />
);
